module.exports = __webpack_public_path__ + "files/1336825883259135b47348957d9d6e8f.png";